import React, { useState } from "react";
import ImageUpload from "../components/ImageUpload";
import { extractTextFromImage } from "../services/ocrService";
import { mapOCRToLead } from "../services/ocrMapper";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";

const LeadScanPage = () => {
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ocrText, setOcrText] = useState("");
  const [mappedData, setMappedData] = useState(null);

  const handleFileSelect = async (selectedFile) => {
    setFile(selectedFile);
    setLoading(true);

    const text = await extractTextFromImage(selectedFile);

    setOcrText(text);

    const mapped = mapOCRToLead(text);
    setMappedData(mapped);

    setLoading(false);
  };

  const handleUseData = () => {
    navigate("/leads/new", { state: { prefill: mappedData } });
  };

  return (
    <div className="p-4 space-y-4">
      <h2 className="text-lg font-semibold">Scan Visiting Card</h2>

      <ImageUpload onFileSelect={handleFileSelect} />

      {loading && <p>Processing OCR...</p>}

      {/* OCR TEXT */}
      {ocrText && (
        <div className="p-3 bg-gray-100 rounded">
          <h3 className="font-medium mb-2">Extracted Text:</h3>
          <pre className="text-sm whitespace-pre-wrap">{ocrText}</pre>
        </div>
      )}

      {/* MAPPED DATA */}
      {mappedData && (
        <div className="p-3 bg-green-50 rounded space-y-2">
          <h3 className="font-medium mb-2">Mapped Fields:</h3>

          <p><b>Name:</b> {mappedData.contact_name || "—"}</p>
          <p><b>Company:</b> {mappedData.company_name || "—"}</p>
          <p><b>Phone:</b> {mappedData.phone || "—"}</p>
          <p><b>Email:</b> {mappedData.email || "—"}</p>
          <p><b>Address:</b> {mappedData.address || "—"}</p>

          {mappedData.notes && (
            <div className="mt-2">
              <b>Notes:</b>
              <pre className="text-sm whitespace-pre-wrap mt-1 bg-white p-2 rounded">
                {mappedData.notes}
              </pre>
            </div>
          )}

          {/* NEXT BUTTON */}
          <Button
            className="mt-3 w-full"
            onClick={handleUseData}
          >
            Use This Data →
          </Button>
        </div>
      )}
    </div>
  );
};

export default LeadScanPage;